import { GQL_createInvoiceVariables } from '@/queries/__generated__/createInvoice';
import { GQL_invoice_invoice } from '@/queries/__generated__/invoice';
import Decimal from '@/utils/decimal';

export const formatDataToMutationInput = (invoice: GQL_invoice_invoice): GQL_createInvoiceVariables => {
  return {
    orderIds: invoice.orders.map(o => o.id),
    issueDate: invoice.issueDate,
    dueDate: invoice.dueDate,
    paymentTerm: invoice.paymentTerm,
    supplierPartyId: invoice.supplierParty.id,
    customerPartyId: invoice.customerParty.id,
    orderDeliveryId: invoice.orderDelivery.id,
    invoicePaymentMethods: invoice.invoicePaymentMethods.map(pm => { return { name: pm.name, amount: pm.amount } }),
    payableRoundingAmount: invoice.payableRoundingAmount,
    payableAmount: invoice.payableAmount,
    legalNotes: invoice.legalNotes,
    customNote: invoice.customNote,
    attachments: invoice.attachments as unknown as File[],
  };
};

// Our agreement with MPS fixes the eFaktura KID layout: customer number at positions
// 1-6, payment type at 7-8, invoice number at 9-15, mod11 check digit at 16.
// The server builds the KID (see KidGeneratorService); these are only what the settings
// and customer forms need to fill in and cap their inputs.
export const EFAKTURA_KID_LENGTH = 16;
export const EFAKTURA_CUSTOMER_NUMBER_LENGTH = 6;

export const OVERDUE_NOTICE_GRACE_PERIOD_DAYS = 14;
export const OVERDUE_NOTICE_MAX_CHARGE_AMOUNT = new Decimal(38);
// Texts are hardcoded since they have to be in this specific
// format to be valid in a legal contexts.
export const AVAILABLE_LEGAL_NOTES = [
  {
    key: 'salgspant',
    text: 'SALGSPANT i henhold til pantelovens paragrafer 3.14 og 23 har vi slagspant(eiendomsforbehold) i de leverte varer inntil kjøpsummen inkl. renter og omkostninger er fullt betalt. Aksept anses ikke som betaling før den er innfridd i sin helhet. Varene sendes for mottakers risiko.',
    // Explanation: the goods sold are the suppliers property until the purchase amount, interest and other fees are fully sold.
  },
];


export const emailRecipients = (
  customerEmail: string | false,
  copyToSupplier: boolean,
  supplierEmail: string | false,
): [string | null, string[]] => {
  let recipient = null;
  const copies: string[] = [];

  if (customerEmail) {
    recipient = customerEmail;
  }

  if (copyToSupplier && supplierEmail && supplierEmail != customerEmail) {
    copies.push(supplierEmail);
  }

  return [ recipient, copies ];
};
